import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {Button} from '@homeaway/react-buttons';
import {Modal} from '@homeaway/react-modal';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_DOWN__12} from '@homeaway/svg-defs';

import {DiscoveryButton} from './discovery-button/DiscoveryButton';
import discoveryItemsPropTypes from './discoveryItemsPropTypes';
import {edapTrigger} from '../../utils/triggerEdap';
import {linkLocations, namedEvents} from '../../utils/edap';

import './Discovery.less';

const MODAL_CNAME = 'DiscoveryModal';
const UL_CNAME = `${MODAL_CNAME}__category`;
const IMG_CNAME = `${MODAL_CNAME}__image img-rounded`;
const CATEGORY_NAME_CLASS = `${MODAL_CNAME}__category-name`;
const DISCOVERY_TOGGLE_CNAME = 'DiscoveryToggle';

function Discovery({
    discoveryBadgeLabel,
    discoveryLabel,
    discoveryVariant,
    showDiscoveryBadge,
    discoveryItems,
    onDiscoveryTabClick
}) {
    const [isOpen, setOpen] = useState(false);

    function toggleChevron() {
        setOpen(!isOpen);

        edapTrigger(namedEvents.HEADER_LINK_CLICK, {actionlocation: linkLocations.HEADER_LINK_DISCOVERY});
        edapTrigger(namedEvents.CTA_SELECTED,
            {
                action_location: linkLocations.HEADER_LINK_DISCOVERY,
                event_action: linkLocations.CTA_HEADER_DISCOVERY_CLICKED
            });

        if (typeof onDiscoveryTabClick === 'function') {
            onDiscoveryTabClick();
        }
    }

    function handleDiscoveryImageClick() {
        edapTrigger(namedEvents.HEADER_LINK_CLICK, {actionlocation: linkLocations.HEADER_LINK_DISCOVERY});
        edapTrigger(namedEvents.CTA_SELECTED,
            {
                action_location: linkLocations.HEADER_LINK_DISCOVERY,
                event_action: linkLocations.CTA_HEADER_DISCOVERY_IMAGE_CLICKED
            });
    }

    function handleDiscoverySubLinkClick() {
        edapTrigger(namedEvents.DESTINATION_LINK_CLICK, {actionlocation: linkLocations.HEADER_LINK_DISCOVERY});
        edapTrigger(namedEvents.CONTENT_TILE_SELECTED, {action_location: linkLocations.HEADER_LINK_DISCOVERY});
    }

    function setClose() {
        setOpen(false);
    }

    const toggleClasses = classNames(
        DISCOVERY_TOGGLE_CNAME,
        'Dropdown__toggle',
        'site-header-nav__toggle',
        'hidden-xs',
        'hidden-sm',
        'hidden-md',
        {
            [`${DISCOVERY_TOGGLE_CNAME}--open`]: isOpen,
            [`${DISCOVERY_TOGGLE_CNAME}--close`]: !isOpen
        }
    );
    const toggleIconClasses = classNames('Dropdown__toggle-icon', {
        'Dropdown__toggle-icon--open': isOpen
    });

    return (
        <React.Fragment>
            <Button
                id={'discovery-button'}
                className={toggleClasses}
                onClick={toggleChevron}
                label={''}
            >
                <DiscoveryButton
                    showDiscoveryBadge={showDiscoveryBadge}
                    discoveryBadgeLabel={discoveryBadgeLabel}
                    discoveryLabel={discoveryLabel}
                    discoveryVariant={discoveryVariant}
                    isWithNav
                />
                <SVGIcon
                    className={toggleIconClasses}
                    markup={CHEVRON_DOWN__12}
                />
            </Button>
            <Modal
                id={'discovery-modal'}
                isOpen={isOpen}
                closeButton={false}
                onClose={setClose}
                header={false}
                renderBackdrop={false}
                className={MODAL_CNAME}
                modalAnimation={'none'}
            >
                <div className={`${MODAL_CNAME}__container`}>
                    {Array.isArray(discoveryItems) && discoveryItems.map((category) => (
                        <div className={`${MODAL_CNAME}__category-container`} key={`${category.itemId}_list`}>
                            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
                            <img
                                src={category.itemImageUrl}
                                alt={category.itemName}
                                className={IMG_CNAME}
                                onClick={handleDiscoveryImageClick}
                            />
                            <p className={CATEGORY_NAME_CLASS}>{category.itemName}</p>
                            <ul className={UL_CNAME}>
                                {category.urlList.map((url, index) => (
                                    <li role="presentation" key={`${category.itemId}_link_${index}`} onClick={handleDiscoverySubLinkClick}>
                                        <a
                                            data-bypass="true"
                                            href={url.link}
                                            role="menuitem"
                                        >
                                            {url.text}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </Modal>
        </React.Fragment>
    );
}

Discovery.propTypes = {
    discoveryBadgeLabel: PropTypes.string,
    discoveryItems: discoveryItemsPropTypes,
    discoveryLabel: PropTypes.string,
    discoveryVariant: PropTypes.oneOf([1, 2, 3]),
    showDiscoveryBadge: PropTypes.bool,
    onDiscoveryTabClick: PropTypes.func
};

export {Discovery};
